(() => {
  const layers = document.querySelectorAll('.burger-layer');
  if (!layers.length) return;
  const loadScript = (url) => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
  const start = async () => {
    try {
      if (!window.gsap) await loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.10.4/gsap.min.js');
      if (!window.ScrollTrigger) await loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.10.4/ScrollTrigger.min.js');
  gsap.registerPlugin(ScrollTrigger);
  
  const burgerLayers = gsap.utils.toArray(".burger-layer");
  
  const initialPositions = {
    "top": "0vh",
    "second": "0vh",
    "third": "0vh",
    "fourth": "0vh"
  };
  
  const spreadPositions = {
    desktop: {
      "top": "-30vh",
      "second": "-20vh",
      "third": "0vh",
      "fourth": "20vh"
    },
    medium: {
      "top": "-24vh",
      "second": "-17vh",
      "third": "-1vh",
      "fourth": "15vh"
    },
    mobile: {
      "top": "-19vh",
      "second": "-13vh",
      "third": "-1vh", 
      "fourth": "10vh"
    }
  };
  
  function getSpreadPositions() {
    if (window.innerWidth <= 1024) {
      return spreadPositions.mobile; // Use mobile spread positions
    } else if (window.innerWidth <= 1700) {
      return spreadPositions.medium; // Use medium spread positions
    } else {
      return spreadPositions.desktop; // Use desktop spread positions
    }
  }
  
  // Function to get ScrollTrigger start and end points based on screen size
  function getScrollTriggerPoints() {
    if (window.innerWidth <= 1024) {
      return { start: "top 50%", end: "top 30%" };
    } else if (window.innerWidth <= 1700) {
      return { start: "top 30%", end: "top 10%" };
    } else {
      return { start: "top 20%", end: "top 0%" };
    }
  }
  
  burgerLayers.forEach((layer) => {
    const layerClass = layer.classList[1];
  
    if (initialPositions[layerClass]) {
      gsap.set(layer, { y: initialPositions[layerClass] });
    }
  
    const spreadPositions = getSpreadPositions();
    const { start, end } = getScrollTriggerPoints();
  
    if (spreadPositions[layerClass]) {
      gsap.to(layer, {
        y: spreadPositions[layerClass],
        opacity: 1,
        duration: 3,
        ease: "power2.out",
        scrollTrigger: {
          trigger: "#layers",
          start: start, // Dynamic start point
          end: end, // Dynamic end point
          scrub: 2,
          // markers: true, // Uncomment to debug
          // pin: true, // Keeps the section in place while scrolling
        },
      });
    }
  
    const labels = layer.querySelectorAll(".label");
    labels.forEach((label) => {
      gsap.to(label, {
        opacity: 1,
        scrollTrigger: {
          trigger: "#layers",
          start: start, // Dynamic start point
          end: end, // Dynamic end point
          scrub: 1,
        },
      });
    });
  });


    } catch (error) {
      layers.forEach(layer => { layer.style.opacity = '1'; });
    }
  };
  const observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) {
      observer.disconnect();
      start();
    }
  }, { rootMargin: '300px' });
  observer.observe(layers[0].closest('#layers') || layers[0]);
})();
